import { TransportationTemperatureAdherenceService } from "./widgets/widget-transportation-temperature-adherence/service/widget-transportation-temperature-adherence.service";
export { LoaderComponent } from "./loader/loader.component";
export { ToggleToSwitchComponent } from "./toggle-to-switch/toggle-to-switch.component"
export {
  WidgetMostAffectedStatesComponent
} from "./widgets/widget-most-affected-states/widget-most-affected-states.component";
export {
  WidgetMostAffectedCustomersComponent
} from "./widgets/widget-most-affected-customers/widget-most-affected-customers.component";
export {
  WidgetRegionwiseOtifBreakupComponent
} from "./widgets/widget-regionwise-otif-breakup/widget-regionwise-otif-breakup.component";
export {
  WidgetDeliveryEndToEndSlaComponent
} from "./widgets/widget-delivery-end-to-end-sla/widget-delivery-end-to-end-sla.component";
export {
  WidgetReturnEndToEndSlaComponent
} from "./widgets/widget-return-end-to-end-sla/widget-return-end-to-end-sla.component";
export {
  WidgetReturnReasonForFailureComponent
} from "./widgets/widget-return-reasons-for-failure/widget-return-reason-for-failure.component";
export {
  WidgetReturnWorstODPairsComponent
} from "./widgets/widget-return-worst-od-pairs/widget-return-worst-od-pairs.component";
export {
  WidgetReturnEndToEndSlaTrendComponent
} from "./widgets/widget-return-end-to-end-trend/widget-return-end-to-end-sla-trend.component";
export {
  WidgetInwardWorstODPairsComponent
} from "./widgets/widget-inward-worst-od-pairs/widget-inward-worst-od-pairs.component";
export {
  WidgetInwardReasonForFailureComponent
} from "./widgets/widget-inward-reasons-for-failure/widget-inward-reason-for-failure.component";
export {
  WidgetInwardEndToEndSlaComponent
} from "./widgets/widget-inward-end-to-end-sla/widget-inward-end-to-end-sla.component";
export {
  WidgetInwardEndToEndSlaTrendComponent
} from "./widgets/widget-inward-end-to-end-trend/widget-inward-end-to-end-sla-trend.component";

export {
  WidgetWarehouseMostAffectedWarehousesComponent
} from "./widgets/widget-warehouse-most-affected-warehouses/widget-warehouse-most-affected-warehouses.component";
export {
  WidgetWarehouseUtilizationComponent
} from "./widgets/widget-warehouse-utilization/widget-warehouse-utilization.component";

export {
  WidgetInventoryAuditAccuracyComponent
} from "./widgets/widget-warehouse-inventory-audit-accuracy/widget-warehouse-inventory-audit-accuracy.component";

export {
  WidgetDamageStorageComponent
} from "./widgets/widget-warehouse-damage-storage/widget-damage-storage.component";
export {
  WidgetTransferWorstODPairsComponent
} from "./widgets/widget-transfer-worst-od-pairs/widget-transfer-worst-od-pairs.component";
export {
  WidgetPerformanceDashboardEndToEndSlaComponent
} from "./widgets/widget-performance-dashboard-end-to-end-sla/widget-performance-dashboard-end-to-end-sla.component";
export {
  WidgetTransportationWorstODPairsComponent
} from "./widgets/widget-transport-most-affected-worst-od-pairs/widget-transport-most-affected-worst-od-pairs.component";
export {
  WidgetTransportationWarehouseUtilizationComponent
} from "./../components/widgets/widget-transport-warehouse-utilization/widget-transportation-warehouse-utilization.component";
export {
  WidgetTransportationNuclearStockpilesComponent
} from "./widgets/widget-transportation-nuclear-stockpiles/widget-transportation-nuclear-stockpiles.component";
export {
  WidgetTransportationTemperatureAdherenceComponent
} from "./widgets/widget-transportation-temperature-adherence/widget-transportation-temperature-adherence.component";
export {
  WidgetRegionWiseDetailComponent
} from "./widgets/widget-region-wise-detail/widget-region-wise-detail.component";
export {
  WidgetOrderDistributionComponent
} from "./widgets/widget-order-distribution/widget-order-distribution.component";

export{ WidgetStatusRigionwiseStatusComponent
} from "./widgets/widget-status-rigionwise-status/widget-status-rigionwise-status.component";
export {
  WidgetStatusBreakupComponent
} from "./widgets/widget-status-breakup/widget-status-breakup.component";
export {
  WidgetStatusPieBreakupComponent
} from "./widgets/widget-status-pie-breakup/widget-status-pie-breakup.component";
export {
  DropDownFilterComponent
} from "./filters/drop-down/drop-down.component";
export {
  DateRangeFilterComponent
} from "./filters/date-range-filter/date-range-filter.component";
export { FilterWrapperComponent } from "./filters/filter-wrapper.component";
export {
  AutocompleteComponent
} from "./filters/autocomplete/autocomplete.component";
export { PaginationComponent } from "./pagination/pagination.component";
export { ShowPagesComponent } from "./show-pages/show-pages.component";
export { GenericDialogBoxComponent} from './generic-dialog-box/generic-dialog-box.component';
export { TabDivComponent } from './tab-div/tab-div.component';
export { WidgetOverallStatusTrendComponent } from './widgets/widget-overall-status-trend/widget-overall-status-trend.component';
export { WidgetOverallCumulativeStatusComponent} from './widgets/widget-overall-cumulative-status/widget-overall-cumulative-status.component';
export { WidgetSlaGraphComponent } from './widgets/widget-sla-graph/widget-sla-graph.component'
